<div class="quote-main-container">
    <app-header *ngIf="showHeader"></app-header>
    <section class="main-content">
      <router-outlet></router-outlet>
    </section>
  </div>